import MONSTRO_5 from "url:../sprites/pedrero.png";
import SOM_10 from "url:../sfx/miumiu.m4a";

export default {
  attack: 2,
  life: 9,
  speed: 2,
  agility: 2,
  weapon: 1,
  armor: 4,
  image: MONSTRO_5,
  sound: SOM_10,
};
